import * as React from 'react';
import './Channels.scss';

import { UserService, StoreService } from 'services/ApiService';
// import Select from 'react-select';
import { Channel, ToastState, User } from 'types';
import ReactTable, { ReactTableDefaults } from 'react-table';
import { ExportToCsv } from 'export-to-csv';
import Toast from 'components/Toast';
import { SearchFilter, TooltipCell, TooltipHeader } from 'helpers/Table';

type ChannelsState = {channels: Channel[], loading: boolean, user: User | null};

export default class Channels extends React.Component<{}, ChannelsState> {
  constructor(props: {}) {
    super(props);
    this.state = {
      channels: [],
      loading: false,
      user: null
    };
  }
  
  reload = async () => {
    let channels: Channel[] = [];
    let curUser = await UserService.fetch();

    channels = curUser.channels;
    for (const eachChannel of channels) {
        let storesInEachChannel = await StoreService.fetchInChannel(eachChannel.id);
        for (const eachStore of storesInEachChannel) {
            if (eachChannel.storesList) {
                eachChannel.storesList =  eachChannel.storesList + ', ' + eachStore.storeOperatorName;
            } else {
                eachChannel.storesList = eachStore.storeOperatorName;
            }
            
        }
    }
    this.setState({loading: false, channels: channels, user: curUser});
  }

  componentDidMount() {
    this.reload();
  }
  
  addLeadingZero(time: Number) {
    let str = time.toString();
    if (str.length < 2) {
      return '0' + str;
    }
    return str;
  }

  cleanDataForCsv() {
    /* tslint:disable:no-string-literal */
    let newChannels = this.state.channels;

    newChannels.map(async obj => {
      // Clean up date objects, rename headers, and order headers
      obj['ChannelNumber'] = obj['id'];
      obj['ChannelName'] = obj['channelName'];
      obj['DateCreated'] = obj['createDate'].toString();
      // obj['storeCount]
      obj['Stores'] = obj['storesList'];

      // Delete unneccessary columns
      Object.keys(obj).forEach((key) => {
        if ((key !== 'ChannelNumber') && (key !== 'ChannelName') && (key !== 'Stores')) {
          delete obj[key];
        }
      });
    });
    return newChannels;
  }

  async downloadAsCsv() {
    let today = new Date();
    let year = today.getFullYear();
    let day = this.addLeadingZero(today.getDay());
    let month = this.addLeadingZero(today.getMonth());
    let hour = this.addLeadingZero(today.getHours());
    let minute = this.addLeadingZero(today.getMinutes());
    let seconds = this.addLeadingZero(today.getSeconds());

    let dateName = `${year}-${month}-${day}__${hour}.${minute}.${seconds}EST`;
    const options = { 
        fieldSeparator: ',',
        filename: `Report_Channels_Export__${dateName}`,
        quoteStrings: '"',
        decimalseparator: '.',
        showLabels: true, 
        showTitle: false,
        useBom: false,
        useKeysAsHeaders: true,
    };

    const csvExporter = new ExportToCsv(options);
    
    try {
      let cleanChannels = this.cleanDataForCsv();
      csvExporter.generateCsv(cleanChannels);
      Toast.present({ message: 'Channels has been succesfully exported' }, ToastState.SUCCESS);
    } catch (err) {
      Toast.present({ message: 'Channels has failed to be exported' }, ToastState.ERROR);
    }
  }

  render() {

    const columns = [{
        Header: <TooltipHeader value="Channel #" />,
        accessor: 'id',
        Filter: SearchFilter
    }, {
        Header: <TooltipHeader value="Channel Name" />,
        accessor: 'channelName',
        Filter: SearchFilter,
        filterMethod: (filter, row) => {
          return row[filter.id].toLowerCase().includes(filter.value.toLowerCase());
        }
    }, {
        Header: <TooltipHeader value="Stores" />,
        accessor: 'storesList',
        Filter: SearchFilter,
        filterMethod: (filter, row) => {
          return row[filter.id].toLowerCase().includes(filter.value.toLowerCase());
        }
    }];

    const { loading } = this.state;
    return (
      <div className="stores">
        <div className="header">
          <div className="header-left">
            <h1>My Report Channels</h1>
          </div>
          <div className="header-right">
            <button className="exportButton" onClick={() => this.downloadAsCsv()}>Export To CSV</button>
          </div>
        </div>        
        <ReactTable
          loading={loading}
          minRows={0}
          filterable={true}
          data={this.state.channels}
          columns={columns}
          column={{
            ...ReactTableDefaults.column,
            Cell: TooltipCell
          }}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/Channels/index.tsx